//src/components/PrivacyPolicy.js
const PrivacyPolicy = () => (
  <div className="p-4 max-w-4xl mx-auto">
    <h1 className="text-2xl font-bold">Política de Privacidad</h1>
    <p>En Cocina Casera, usamos cookies solo para guardar tus preferencias, como tu dirección, y mejorar tu experiencia. No compartimos tus datos con terceros, excepto para procesar pedidos (e.g., WhatsApp). ¡Tu información está segura!</p>
  </div>
);
export default PrivacyPolicy;